import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, FieldArray, reduxForm, formValueSelector, change } from 'redux-form';
import { Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';

import CommonFormComponent from '../../CommonField/CommonFormComponent';
import Link from '../../Link';

import submit from './submit';
import validate from './validate';
import { url } from '../../../config.js';
import { formatURL } from '../../../helpers/formatURL';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import { formatLocale, formatLocaleData } from '../../../helpers/formatLocale';
import messages from '../../../locale/jsonMessages';
import { AddPlusIcon, GoBackArrow, RemoveIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon.js';

import cp from '../../../components/commonStyle.css';
import s from './EditBlogDetails.css';

class EditBlogDetails extends React.Component {

  constructor(props) {
    super(props);
    if (typeof window !== 'undefined') {
      this.CustomEditor = require('../../Common/Editor/CustomEditor');
    }
    this.state = { editorHtml: '' };
    this.handlePageTitle = this.handlePageTitle.bind(this);
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
  };

  static defaultProps = {
    data: []
  };

  async handlePageTitle(e) {
    const { change } = this.props;
    if (e.target.value) {
      await change('pageUrl', formatURL(e.target.value));
    } else {
      await change('pageUrl', '');
    }
  }

  renderQuill = ({ input, labelText, meta: { touched, error }, isRequiredInput }) => {
    const { Editor } = this.CustomEditor;
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <label className='commonLabelText'>
          {labelText}{isRequiredInput && <sub className='isRequiredStar'>*</sub>}
        </label>
        <Editor {...input} />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  }

  renderDynamicBlogDetails = ({ fields }) => {
    const { formatMessage } = this.props.intl;
    const { languages, dynamicBlogDetails } = this.props;

    const activeLanguageCodes = languages?.map(item => formatLocaleData(item)) || [];
    const usedLanguages = dynamicBlogDetails?.map(item => item?.language) || [];

    return (
      <div className={cp.languageBox}>
        {fields.map((item, index) => {
          const currentLanguage = fields.get(index)?.language;

          const availableLanguages = activeLanguageCodes.filter(
            locale => !usedLanguages.includes(locale) || locale === currentLanguage
          );

          const languageValue = [
            { value: '', label: formatMessage(messages.chooseLanguageLabel) },
            ...availableLanguages.map(locale => ({
              value: locale,
              label: formatLocale(locale)
            }))
          ];

          return (
            <div key={index}>
              <div className='oneColumnGrid'>
                <Field
                  name={`${item}.language`}
                  component={CommonFormComponent}
                  inputClass='commonSelectField'
                  labelText={formatMessage(messages.language)}
                  placeholder={formatMessage(messages.language)}
                >
                  {languageValue.map(lang => (
                    <option key={lang.value} value={lang.value}>{lang.label}</option>
                  ))}
                </Field>

                {/* Page Title */}

                <Field
                  name={`${item}.metaTitle`}
                  type="text"
                  component={CommonFormComponent}
                  placeholder={formatMessage(messages.metaTitleLabel)}
                  labelText={formatMessage(messages.metaTitleLabel)}
                  inputClass='commonInputField'
                  isRequiredInput
                />
                <Field
                  name={`${item}.metaDescription`}
                  componentClass={'textarea'}
                  inputClass='commonTextAreaField'
                  component={CommonFormComponent}
                  labelText={formatMessage(messages.metaDescriptionLabel)}
                  placeholder={formatMessage(messages.metaDescriptionLabel)}
                  isRequiredInput
                />

                <Field
                  name={`${item}.pageTitle`}
                  type="text"
                  component={CommonFormComponent}
                  placeholder={formatMessage(messages.pageTitleLabel)}
                  labelText={formatMessage(messages.pageTitleLabel)}
                  inputClass='commonInputField'
                  isRequiredInput
                />

                <Field
                  name={`${item}.content`}
                  labelText={formatMessage(messages.contentLabel)}
                  component={this.renderQuill}
                  isRequiredInput
                />
              </div>
              <div className={cx(cp.displayFlex, cp.gap16, cp.justifyContentSpaceBetween, cp.flexWrap, cp.spaceTop2, { [cp.languageBtnContainerOne]: index != 0 })}>
                <div className={cx(cp.displayFlex, cp.gap16, cp.flexWrap, cp.justifyContentFlexEnd, cp.flexGrow)}>
                  {fields.length > 1 &&
                    <Button
                      onClick={() => fields.remove(index)}
                      className={cx(cp.linkBtnPrimaryStyle, cp.displayFlex, cp.gap4, cp.alignCenter, s.addLanguageText)}
                    >
                      <RemoveIcon />
                      {formatMessage(messages.deleteLanguage)}
                    </Button>
                  }
                  {fields.length <= (languages?.length - 1) && index === fields.length - 1 &&
                    <Button
                      onClick={() => fields.push({ language: '', pageTitle: '', content: '' })}
                      className={cx(cp.linkBtnPrimaryStyle, cp.displayFlex, cp.gap4, cp.alignCenter, s.addLanguageText)}
                    >
                      <AddPlusIcon />
                      {formatMessage(messages.addLanguage)}
                    </Button>
                  }
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { error, handleSubmit, submitting, siteName } = this.props;
    const { formatMessage } = this.props.intl;

    if (typeof window !== 'undefined') {
      return (
        <div className='siteAdminCenterContainer'>
          <div className={cx('singleBtnFlexEnd', cp.spaceBottom4)}>
            <Link to={"/siteadmin/content-management"} className='goBackLink'>
              <GoBackArrow />
              <FormattedMessage {...messages.goBack} />
            </Link>
          </div>
          <div className='siteAdminCenterContainerBox'>
            <h1 className='siteAdminHeading'><FormattedMessage {...messages.editPageDetails} /></h1>
            <form onSubmit={handleSubmit(submit)}>
              {error && <strong>{formatMessage(error)}</strong>}
              <div className={s.addBlogCommonInputGrp}>
                <div className="oneColumnGrid">
                  <Field
                    name="pageUrl"
                    type="text"
                    component={CommonFormComponent}
                    isAddon={true}
                    addonContainerClass={'addonMobileWrapper'}
                    suffixLabel={`${url}${formatMessage(messages.pageLabel)}`}
                    labelText={formatMessage(messages.pageUrl)}
                    placeholder={formatMessage(messages.pageUrl)}
                    isRequiredInput
                  />
                  <Field
                    name="footerCategory"
                    component={CommonFormComponent}
                    labelText={formatMessage(messages.footerCategoryLabel)}
                    placeholder={formatMessage(messages.footerCategoryLabel)}
                    inputClass='commonSelectField'
                  >
                    <option value="">{formatMessage(messages.ChooseFooterCategory)}</option>
                    <option value={siteName}>{siteName}</option>
                    <option value="discover">{formatMessage(messages.discover)}</option>
                    <option value="hosting">{formatMessage(messages.hosting)}</option>
                  </Field>
                </div>
              </div>
              <FieldArray
                name="dynamicBlogDetails"
                component={this.renderDynamicBlogDetails}
                rerenderOnEveryChange={true}
              />
              <div className={cx(cp.spaceTop4, 'singleBtnFlexEnd')}>
                <Button className={cx(cp.btnPrimary)} type="submit" disabled={submitting}>
                  <FormattedMessage {...messages.save} />
                </Button>
              </div>
            </form>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  }
}

EditBlogDetails = reduxForm({
  form: 'BlogDetails',
  validate
})(EditBlogDetails);

const blogFormSelector = formValueSelector('BlogDetails');

const mapState = (state) => ({
  siteName: state.siteSettings.data.siteName,
  languages: state.runtime.isActiveLanguages,
  dynamicBlogDetails: blogFormSelector(state, 'dynamicBlogDetails'),
  activeLanguageCodes: state.runtime.isActiveLanguages.map(item => formatLocaleData(item))
});

const mapDispatch = { change };

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(EditBlogDetails)));